import { ObalMaterialuNrSrBezchybnostApi } from 'evidencna-aplikacia-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';
import Uuid from '../../../model/Uuid';
import { ObalMaterialuNrSrBezchybnostFormData } from '../../../model/pracovnyKrok/ObalMaterialuNrSrBezchybnostFormData';

const client = new ObalMaterialuNrSrBezchybnostApi(apiConfiguration(evidenciaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const createObalMaterialuNrSrBezchybnostClient = async (
  uuid: Uuid,
  obalMaterialu: ObalMaterialuNrSrBezchybnostFormData,
  headers?: object,
): Promise<ClientResponse<Blob>> => {
  const {
    data,
    status,
  } = await client.createObalMaterialuNrSrBezchybnost(uuid, obalMaterialu, { ...headers, responseType: 'blob' });

  return {
    data: data && new Blob([data]),
    responseCode: status,
  };
};

export const updateObalMaterialuNrSrBezchybnostClient = async (
  uuid: Uuid,
  obalMaterialu: ObalMaterialuNrSrBezchybnostFormData,
  headers?: object,
): Promise<ClientResponse<Blob>> => {
  const {
    data,
    status,
  } = await client.updateObalMaterialuNrSrBezchybnost(uuid, obalMaterialu, { ...headers, responseType: 'blob' });
  return {
    data: data && new Blob([data]),
    responseCode: status,
  };
};
